import api from './BaseApi';

export const createSecurityLane = async (data) => {
    try {
        const response = await api.post('/admin/security-lanes', data);
        return response; 
    } catch (error) {
        console.error('Create security lane error:', error);
        return error;
    }
};

export const getSecurityLanes = async (params) => {
    try {
        const response = await api.get('/admin/security-lanes', { params });
        return response.data;
    } catch (error) {
        console.error('Get security lanes error:', error);
    }
};

export const updateSecurityLane = async (id, payload) => {
    try {
        const response = await api.put(`/admin/security-lanes/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update security lane error:', error);
        return error;
    }
};

export const deleteSecurityLane = async (id) => {
    try {
        const response = await api.delete(`/admin/security-lanes/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete security lane error:', error);
        return error;
    }
};

export const updateSecurityLaneStatus = async (id, payload) => {
    try {
        const response = await api.patch(`/admin/security-lanes/${id}/status`, payload);
        return response;
    } catch (error) {
        console.error('Update security lane status error:', error);
        throw error;
    }
};